import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useUserAuth } from "../context/UserAuthContext";

export default function ProfileDeletePage() {
  const navigate = useNavigate();
  const { setPreviousLocation, setVerifiedDeletion } = useUserAuth();

  useEffect(() => {
    setPreviousLocation("/profile");
    setVerifiedDeletion(true);
    navigate("/signup", {
      state: { previousLocation: "/profile/delete/confirm" },
    });
  }, []);
  return <div className="widthController"></div>;
}
